exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HistoryEvents-HistoryEvents-Table_container{width:100%;border-spacing:0;border-collapse:collapse}.HistoryEvents-HistoryEvents-row_container{padding:0 15px;padding:0 .9375rem;margin:0 auto;max-width:1280px;background:#fff}.HistoryEvents-HistoryEvents-header_color{border:1px solid #0376a3;background:#0376a3;color:#fff}.HistoryEvents-HistoryEvents-spirotech_header_color{border:1px solid #fae04e;background:#fae04e;color:#000}.HistoryEvents-HistoryEvents-data_color{border:1px solid #0376a3;padding:0 10px}@media (min-width:721px){.HistoryEvents-HistoryEvents-data_color{min-width:7rem}}.HistoryEvents-HistoryEvents-spirotech_data_color{border:1px solid #fae04e;color:#000;padding:0 10px}@media (min-width:721px){.HistoryEvents-HistoryEvents-spirotech_data_color{min-width:7rem}}.HistoryEvents-HistoryEvents-center{text-align:center}.HistoryEvents-HistoryEvents-red{background:red!important}", ""]);

// exports
exports.locals = {
	"Table_container": "HistoryEvents-HistoryEvents-Table_container",
	"row_container": "HistoryEvents-HistoryEvents-row_container",
	"header_color": "HistoryEvents-HistoryEvents-header_color",
	"spirotech_header_color": "HistoryEvents-HistoryEvents-spirotech_header_color",
	"data_color": "HistoryEvents-HistoryEvents-data_color",
	"spirotech_data_color": "HistoryEvents-HistoryEvents-spirotech_data_color",
	"center": "HistoryEvents-HistoryEvents-center",
	"red": "HistoryEvents-HistoryEvents-red"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/HistoryEvents/HistoryEvents.css
// module id = 1091
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20